import callApi from '../../util/apiCaller';
// Export Constants
export const ADD_FORECAST_OPPORTUNITIES = 'ADD_FORECAST_OPPORTUNITIES';
export const FETCH_FORECAST_PERIODS = 'FETCH_FORECAST_PERIODS';
export const ADD_FORECAST_HISTORY_OPPORTUNITIES = 'ADD_FORECAST_HISTORY_OPPORTUNITIES';
export const ADD_FORECAST_OPPORTUNITY_LOGS = 'ADD_FORECAST_OPPORTUNITY_LOGS';

export function fetchOpportunities(params = {}, isWeighted = false) {
  const empty = {
    winRates: {}, ptdWins: {}, forecasts: [], untrackedOpportunities: [], start: null, end: null, sync_date: null, forecastId: null,
  };
  return (dispatch) => {
    dispatch({
      type: ADD_FORECAST_OPPORTUNITIES, ...empty, status: 'loading', errors: null,
    });
    const included = [
      'owners',
      'products',
      'repTypes',
      'repRegions',
      'lineItems',
      'opportunityCompetitors',
    ];
    const endpoint = 'search/forecast';
    const { team } = params;
    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    delete params.team;
    const p4 = callApi(`${endpoint}/?include=${included.join(',')}&getWeighted=${isWeighted}${teamId}`, 'POST', params);
    const p = new Promise((resolve, reject) => {
      Promise.all([p4]).then(
        ([res4]) => {
          resolve({
            isHistory: params.isHistory || false,
            winRates: res4.win_rates || {},
            ptdWins: res4.ptd_wins || {},
            forecastAccuracies: res4.forecastAcc || {},
            forecasts: res4.forecasts,
            untrackedOpportunities: res4.untracked_opportunities || [],
            start: res4.start,
            end: res4.end,
            syncDate: res4.sync_date,
            forecastId: res4.forecast_id,
            owners: res4.owners,
            status: 'loaded',
            errors: null,
            isWeighted,
          });
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    p.then(
      (results) => {
        dispatch({ type: ADD_FORECAST_OPPORTUNITIES, ...empty, ...results });
      },
      (errors) => {
        dispatch({
          type: ADD_FORECAST_OPPORTUNITIES, ...empty, status: 'error', errors,
        });
      },
    );
    return p;
  };
}

export function reset() {
  return (dispatch) => {
    dispatch({
      type: ADD_FORECAST_OPPORTUNITIES, winRates: {}, ptdWins: {}, forecasts: [], errors: {}, start: null, end: null, sync_date: null,
    });
    return Promise.resolve();
  };
}

export function getOpportunityLogs(forecastId, opportunityId) {
  return (dispatch) => {
    dispatch({ type: ADD_FORECAST_OPPORTUNITY_LOGS, status: 'loading', opportunityId });
    // const p = callApi(`search/forecast/${forecastId}/opportunities/${opportunityId}/logs`, 'GET');
    const p = callApi(`search/opportunities/${opportunityId}/logs`, 'GET');
    p.then(
      (logDetails) => {
        dispatch({
          type: ADD_FORECAST_OPPORTUNITY_LOGS, status: 'loaded', opportunityId, logDetails,
        });
      },
      (error) => {
        dispatch({
          type: ADD_FORECAST_OPPORTUNITY_LOGS, status: 'error', opportunityId, error,
        });
      },
    );
    return p;
  };
}

export function fetchHistoryOpportunities(params = {}) {
  const empty = { forecasts: [], selectedPeriod: null };
  return (dispatch) => {
    dispatch({
      type: ADD_FORECAST_HISTORY_OPPORTUNITIES, ...empty, status: 'loading', errors: null,
    });
    const included = [
      'owners',
      'products',
      'repTypes',
      'repRegions',
      'lineItems',
      'opportunityCompetitors',
    ];
    const { team } = params;
    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    delete params.team;
    const p4 = callApi(`search/forecast/history?include=${included.join(',')}${teamId}`, 'POST', params);
    const p = new Promise((resolve, reject) => {
      Promise.all([p4]).then(
        ([res4]) => {
          resolve({
            forecasts: res4.forecasts,
            selectedPeriod: params.selectedPeriod,
            status: 'loaded',
            errors: null,
          });
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    p.then(
      (results) => {
        dispatch({ type: ADD_FORECAST_HISTORY_OPPORTUNITIES, ...empty, ...results });
      },
      (errors) => {
        dispatch({
          type: ADD_FORECAST_HISTORY_OPPORTUNITIES, ...empty, status: 'error', errors,
        });
      },
    );
    return p;
  };
}

export function resetHistory() {
  return (dispatch) => {
    dispatch({
      type: ADD_FORECAST_HISTORY_OPPORTUNITIES, forecasts: [], selectedPeriod: null, errors: {},
    });
    return Promise.resolve();
  };
}

export function fetchForcastPeriods(params = {}) {
  return (dispatch) => {
    dispatch({ type: FETCH_FORECAST_PERIODS, periods: [] });
    const p = callApi('forecast/periods', 'GET', params);
    p.then(
      (results) => {
        dispatch({ type: FETCH_FORECAST_PERIODS, ...results, params });
      },
      () => {
        dispatch({ type: FETCH_FORECAST_PERIODS, periods: [], params });
      },
    );
    return p;
  };
}
